import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { name: '今日大瓜', path: '/category/today-hot' },
      { name: '网红黑料', path: '/category/influencer-scandal' },
      { name: '明星塌房', path: '/category/celebrity-downfall' },
      { name: '实时爆料', path: '/category/realtime-expose' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '平台口碑', path: '/about' },
      { name: '联系我们', path: '/about' },
      { name: '爆料投稿', path: '/about' },
    ],
  },
  {
    title: '法律声明',
    links: [
      { name: '隐私政策', path: '/about' },
      { name: '用户协议', path: '/about' },
      { name: '免责声明', path: '/about' },
      { name: '版权声明', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[40%]">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🔥</span>
              <span className="font-heading text-2xl font-bold tracking-tight">911爆料网</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-sm">
              全网独家爆料首发平台，24小时实时追踪网红黑料、明星塌房事件。海量独家内幕免费开放，第一时间掌握全网热议话题。
            </p>
            <div className="space-y-3">
              <p className="text-xs font-medium text-foreground-400 uppercase tracking-wide">获取内幕通知</p>
              <form data-readdy-form="newsletter-footer" className="flex flex-col sm:flex-row gap-3" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="email"
                  name="email"
                  placeholder="输入你的邮箱地址"
                  className="flex-1 bg-transparent border-b border-foreground-700 px-1 py-2 text-sm text-background-50 placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap px-6 py-2 rounded-full border border-foreground-600 text-background-50 text-sm font-medium cursor-pointer transition-all duration-200 hover:border-primary-400 hover:text-primary-400"
                >
                  订阅追踪
                </button>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold mb-4 text-background-50">
                  <Link to={col.links[0]?.path || '/'} className="hover:text-primary-400 transition-colors">
                    {col.title}
                  </Link>
                </h4>
                <ul className="space-y-3">
                  {col.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 911爆料网. 本站内容均来自网友投稿，不代表本站立场。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-sm cursor-pointer" rel="nofollow">
              <i className="ri-weibo-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-sm cursor-pointer" rel="nofollow">
              <i className="ri-wechat-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-sm cursor-pointer" rel="nofollow">
              <i className="ri-tiktok-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}